import { render } from "./BodyApp.vue?vue&type=template&id=4ea2d2af"
import script from "./BodyApp.vue?vue&type=script&lang=js"
export * from "./BodyApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__